module.exports = __webpack_public_path__ + "static/media/SeaBgDomestic.b7766ab2.svg";